<style lang="less">
  .image-uploader {
    .el-upload {
      width: 128px;
      height: 128px;
      i {
        position: relative;
        top: -5px;
      }
    }
    .el-upload-list {
      &__item {
        width: 128px;
        height: 128px;
      }
    }
  }
  .item-tips {
    font-size: 13px;
    line-height: 13px;
    color: #a3a3a3;
  }
</style>

<template>
  <el-card>
    <div slot="header">
      <h1>{{ activity ? '“' + activity.activityName + '”' : '' }}页面设置</h1>
    </div>
    <el-tabs type="card" v-model="tabName" @tab-click="handleClick" :before-leave="handleLeave">
      <el-tab-pane label="首页显示设置" name="home-show">首页显示设置</el-tab-pane>
      <el-tab-pane label="轮播图" name="carousel-list">轮播图</el-tab-pane>
      <el-tab-pane label="本月主打" name="flagship">本月主打</el-tab-pane>
      <el-tab-pane label="商品推荐" name="recommend">商品推荐</el-tab-pane>
    </el-tabs>
    <div style="padding: 0 60px;margin-top: 25px">
      <el-form ref="form" :model="form" :rules="rules" @validate="formValidate" v-loading="loading" label-width="110px">
        <el-form-item label="轮播图名称：" prop="name">
          <el-input v-model="form.name" placeholder="请输入轮播图名称" :clearable="true" style="width: 500px"/>
        </el-form-item>
        <el-form-item label="开始时间：" prop="startTime">
          <el-date-picker type="datetime" v-model="form.startTime" placeholder="请选择开始时间"
                          :picker-options="pickerStartOptions" :editable="false"
                          style="width: 500px"></el-date-picker>
        </el-form-item>
        <el-form-item  label="结束时间：" prop="endTime">
          <el-date-picker type="datetime" v-model="form.endTime" placeholder="请选择结束时间"
                          :picker-options="pickerEndOptions" :editable="false"
                          style="width: 500px"></el-date-picker>
        </el-form-item>
        <el-form-item label="链接地址：" prop="url">
          <el-input v-model="form.url" placeholder="请输入链接地址" :clearable="true" style="width: 500px"/>
        </el-form-item>
        <el-form-item label="图片上传：" prop="path">
          <el-upload class="image-uploader" :action="uploadPath" list-type="picture-card"
                     :auto-upload="true" :headers="headers" :data="uploadParam"
                     :on-success="handleSuccess" :on-error="handleError" :on-exceed="handleExceed"
                     accept=".jpg,.jpeg,.png"
                     :beforeUpload="beforeBannerUpload"
                     :limit="1" :file-list="fileList">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="加载失败"/>
              <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="加载失败"/>
          </el-dialog>
        </el-form-item>
        <el-form-item label="">
          <div class="item-tips">建议上传文件大小不超过500K，尺寸(1440 × 600)</div>
        </el-form-item>
        <el-form-item label="权重：" prop="weight">
          <el-input v-model="form.weight" placeholder="请输入权重" :clearable="true" style="width: 500px"/>
        </el-form-item>
        <el-form-item label="">
          <div class="item-tips">权重数值在0~255之间，数值越大前台轮播图显示位置越靠前</div>
        </el-form-item>
        <el-form-item style="margin-top: 40px">
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'
  import store from '@/store'
  const { mapGetters } = createNamespacedHelpers('activityBanners')

  export default {
    data() {
      return {
        tabName: 'carousel-form',
        activity: null,
        loading: false,
        isEdit: false,
        isChange: false,
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        uploadParam: {
          folder: 'activityBanners'
        },
        form: {
          name: '',
          startTime: '',
          endTime: '',
          url: '',
          path: '',
          pathUrl: '',
          weight: '0'
        }
      }
    },
    inject: ['reload'],
    computed: {
      pickerStartOptions() {
        return {
          disabledDate: (time) => {
            return time.getTime() > Date.parse(this.form.endTime)
          }
        }
      },
      pickerEndOptions() {
        return {
          disabledDate: (time) => {
            return time.getTime() < Date.parse(this.form.startTime)
          }
        }
      },
      uploadPath() {
        return this.$config.api.baseURL + '/activity-image-upload'
      },
      headers() {
        const { token } = store.state.auth
        return {
          'Authorization': `Bearer ${token}`
        }
      },
      rules() {
        const checkUrl = (rule, value, callback) => {
          if (value === '') {
            callback()
          } else {
            if (!(/^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/.test(value))) {
              callback(new Error('请输入正确格式链接地址'))
            } else {
              callback()
            }
          }
        }
        const checkWeight = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入权重'))
          } else {
            if (!(/^([1-9]\d*|0)$/.test(value))) {
              callback(new Error('请输入正确格式权重'))
            } else {
              if (value < 0 || value > 255) {
                callback(new Error('请输入0~255之间权重'))
              } else {
                callback()
              }
            }
          }
        }
        return {
          name: this.$formHelper.requiredRuleFactory('请输入轮播图名称'),
          startTime: this.$formHelper.requiredRuleFactory('请选择开始时间'),
          endTime: this.$formHelper.requiredRuleFactory('请选择结束时间'),
          url: [{ validator: checkUrl, trigger: 'blur' }],
          path: this.$formHelper.requiredRuleFactory('请上传图片'),
          weight: [{ required: true, message: '请输入权重', trigger: 'blur' }, { validator: checkWeight, trigger: 'blur' }]
        }
      },
      ...mapGetters(['document'])
    },
    methods: {
      handleClick(tab) {
        if (tab.name != this.tabName) {
          if (this.isChange) {
            this.$confirm('您当前编辑结果未提交，是否确定离开？', '提示', {
              type: 'warning'
            }).then(() => {
              this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
            }).catch(() => {
              return false
            })
          } else {
            this.$router.push({ name: 'activity-activity-pagesetting-' + tab.name, query: { activityId: this.activity.id }})
          }
        }
      },
      handleLeave() {
        return false
      },
      formValidate() {
        this.isChange = true
      },
      async onSubmit() {
        try {
          await new Promise((resolve, reject) => {
            this.$refs['form'].validate((valid) => {
              valid ? resolve(true) : reject(false)
            })
          })
        } catch (e) {
          return false
        }
        const formData = _.cloneDeep(this.form)
        formData.activityId = this.activity.id
        try {
          await this.$store.dispatch(this.isEdit ? 'activityBanners/update' : 'activityBanners/create', formData)
          this.$message.success('提交成功')
          this.reload()
        } catch (err) {
          this.$message.error(err.response.data.message)
        }
        this.loading = false
      },
      handleRemove() {
        this.fileList = []
        this.form.path = ''
        this.isChange = true
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleSuccess(res, file) {
        this.fileList.push(file)
        this.form.path = res.data.path
        this.loading = false
        this.isChange = true
      },
      handleError() {
        this.$message.error('上传失败')
        this.loading = false
        this.isChange = true
      },
      handleExceed() {
        this.$message.warning('只能上传一张图片')
        return false
      },
      beforeBannerUpload(file) {
        const isLt4M = file.size / 1024 / 1024 <= 4
        if(!isLt4M) {
          this.$message.warning('上传图片文件大小不能超过4M')
          return false
        }
        this.loading = true
      },
      initForm() {
        const document = _.cloneDeep(this.document)
        this.form = _.cloneDeep(document)
        this.fileList = [{name: this.form.path, url: this.form.pathUrl}]
      }
    },
    async mounted() {
      const { activityId = 0 } = this.$route.query
      try {
        const { document } = await this.$store.dispatch('activities/document', activityId)
        this.activity = document
      } catch (err) {
        this.$message.error('活动不存在')
        this.$router.push({ name: 'activity-activity' })
      }
      const { id = 0 } = this.$route.params
      if (id) {
        this.isEdit = true
        try {
          const { document } = await this.$store.dispatch('activityBanners/document', id)
          this.initForm()
        } catch (err) {
          this.$message.error('轮播图不存在')
          this.$router.push({ name: 'activity-activity-pagesetting-carousel-list', query: { activityId: this.activity.id }})
        }
      }
    }
  }
</script>
